import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';

import { BANNERS } from '@/constants';
import { usePageProps } from '@/hooks';

import { Block, WithoutWrapper, Wrapper } from './Banner.styles';

function Banner({
  id,
  slot,
  isSticky = false,
  hide = null,
  styles = {},
  blockStyles = {},
  as = 'section',
}) {
  const { path } = usePageProps();

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent('bn-slot-display', { detail: { 'bn-slots': [slot] } })
    );
  }, [path]);

  if (slot === BANNERS.catfish.slot) {
    return <WithoutWrapper id={id} data-bn-slot={slot} />;
  }

  return (
    <Wrapper as={as} style={{ ...styles }} $sticky={isSticky} $hide={hide}>
      <Block
        as={as === 'tr' ? 'td' : 'div'}
        $blockStyles={blockStyles}
        id={id}
        data-bn-slot={slot}
      />
    </Wrapper>
  );
}

Banner.propTypes = {
  id: PropTypes.string.isRequired,
  slot: PropTypes.string.isRequired,
  isSticky: PropTypes.bool,
  styles: PropTypes.objectOf(PropTypes.any),
  blockStyles: PropTypes.objectOf(PropTypes.any),
  hide: PropTypes.string,
  as: PropTypes.string,
};

export default memo(Banner);
